export default __webpack_public_path__ + "static/media/whiteDiscord.06f15e01.svg";